module.exports = ".row{\r\n    \r\n}\r\n\r\n.row .col-md-3{\r\n    padding:10px 15px 0px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/manual-lottery/manual-lottery-token/manual-lottery-token.component.css
// module id = ./src/app/allocation/manual-lottery/manual-lottery-token/manual-lottery-token.component.css
// module chunks = main